const menu = {
  key: "salesOrderInboundMessages",
  route: "/legacy/sales-order-inbound-messages",
  label: "sidebar.salesOrderInboundMessages",
  icon: "faEnvelopeOpenText",
  group: "sales",
  order: 22,
  permission: "legacy.salesOrderInboundMessages.read"
};

export default menu;